module.exports = __webpack_public_path__ + "img/product2.f111f844.jpg";